/** Max character lengths for the create / edit channel form fields. The name
 *  cap mirrors the backend's 50-char limit so the input stops at the boundary
 *  instead of erroring only on submit. */
export const CHANNEL_NAME_MAX_LENGTH = 50;
export const CHANNEL_DESCRIPTION_MAX_LENGTH = 260;
